<template>
	<div v-if="isVisible" v-bind="$attrs">
		<slot />
	</div>
</template>

<script lang="ts" setup>
	import R3DivClass from './classes/R3Div.classes';


	const r3Div = new R3DivClass();

	const isVisible = computed(() => r3Div.visible);

	type ExposeType = {

	} & typeof r3Div;

	const expose = {

	} as ExposeType

	useExposeProperties(expose, r3Div);

	defineExpose(expose)

	// defineExpose({
	// 	...toRefs(r3Div)
	// })
</script>